import React, { useState, useEffect, useContext } from "react";

import lbl from "../../data/Labels.json";

import Img from "../common/Img";

import db from "../../services/query";
import FabButtons from "./FinanceFabButtons";

import { PopUpContext } from "../../contexts/popUpContext";

import PastBalanceBtn from "./PastBalanceBtn";
import PaymentsList from "./FinancePaymentsList";
import ReportItemList from "./ReportItemList";
import ReportItemHeader from "../common/ReportItemHeader";
import FinanceProfileChart from "./FinanceProfileChart";
import FinanceSummaryCard from "./FinanceSummaryCard";
import MainPrintLink from "../common/MainPrint";

const FinanceProfile = (props) => {
  const { tid } = props.match.params;

  const [activeYear, setYear] = useState(0);
  const [data, updateData] = useState([]);

  const { popUp } = useContext(PopUpContext);

  useEffect(async () => {
    const ac = new AbortController();
    requestData();
    return () => ac.abort();
  }, [popUp]);

  const requestData = async () => {
    let query = `teachers/${tid}/salary`;

    await db.getAll(query).then(({ data }) => {
      updateData(data);
    });
  };

  return (
    <React.Fragment>
      <div className="finance-profile-area">
        <div className="std-profile">
          <div className="wrapper">
            <Img src={data?.summary?.teacher_photo} border={true} />
          </div>
        </div>
        <div className="overall-summary">
          <div className="wrapper">
            <p>{lbl.OverallBalance}</p>
            <h1>{data?.summary?.overall_balance}</h1>
          </div>
        </div>
        <div className="controls">
          <FabButtons cache={tid} />
          <MainPrintLink path={`teacher-salary-report/${tid}/`} />
        </div>
      </div>
      <div className="finance-report-area">
        <div className="report-container _75-per">
          <div className="report-header print-btn">
            <div className="title">
              <p>{lbl.Details}</p>
            </div>
            <div className="controls">
              <MainPrintLink path={`teacher-salary-report/${tid}/${activeYear}`} />
            </div>
          </div>
          <div className="report-table-area">
            <PaymentsList activeYear={data?.data && data.data[activeYear]} />
          </div>
          <div className="report-summary-area">
            <FinanceSummaryCard title={lbl.Summary} data={data} />
          </div>
        </div>
        <FinanceProfileChart data={data?.data && data.data[activeYear]} />
        <div className="report-container _25-per">
          <ReportItemHeader title={lbl.Semester} />
          <ReportItemList
            data={data}
            setYear={setYear}
            activeYear={activeYear}
          />
          <PastBalanceBtn data={data} cache={tid} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FinanceProfile;
